import type * as Types from '../../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GoogleClassroomConnectionQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GoogleClassroomConnectionQuery = { __typename?: 'RootQueryType', currentUser?: { __typename?: 'User', id: string, googleClassroomConnected?: boolean | null } | null };


export const GoogleClassroomConnectionDocument = gql`
    query GoogleClassroomConnection {
  currentUser {
    id
    googleClassroomConnected
  }
}
    `;

/**
 * __useGoogleClassroomConnectionQuery__
 *
 * To run a query within a React component, call `useGoogleClassroomConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGoogleClassroomConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGoogleClassroomConnectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGoogleClassroomConnectionQuery(baseOptions?: Apollo.QueryHookOptions<GoogleClassroomConnectionQuery, GoogleClassroomConnectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GoogleClassroomConnectionQuery, GoogleClassroomConnectionQueryVariables>(GoogleClassroomConnectionDocument, options);
      }
export function useGoogleClassroomConnectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GoogleClassroomConnectionQuery, GoogleClassroomConnectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GoogleClassroomConnectionQuery, GoogleClassroomConnectionQueryVariables>(GoogleClassroomConnectionDocument, options);
        }
// @ts-ignore
export function useGoogleClassroomConnectionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GoogleClassroomConnectionQuery, GoogleClassroomConnectionQueryVariables>): Apollo.UseSuspenseQueryResult<GoogleClassroomConnectionQuery, GoogleClassroomConnectionQueryVariables>;
export function useGoogleClassroomConnectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GoogleClassroomConnectionQuery, GoogleClassroomConnectionQueryVariables>): Apollo.UseSuspenseQueryResult<GoogleClassroomConnectionQuery | undefined, GoogleClassroomConnectionQueryVariables>;
export function useGoogleClassroomConnectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GoogleClassroomConnectionQuery, GoogleClassroomConnectionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GoogleClassroomConnectionQuery, GoogleClassroomConnectionQueryVariables>(GoogleClassroomConnectionDocument, options);
        }
export type GoogleClassroomConnectionQueryHookResult = ReturnType<typeof useGoogleClassroomConnectionQuery>;
export type GoogleClassroomConnectionLazyQueryHookResult = ReturnType<typeof useGoogleClassroomConnectionLazyQuery>;
export type GoogleClassroomConnectionSuspenseQueryHookResult = ReturnType<typeof useGoogleClassroomConnectionSuspenseQuery>;
export type GoogleClassroomConnectionQueryResult = Apollo.QueryResult<GoogleClassroomConnectionQuery, GoogleClassroomConnectionQueryVariables>;